import { cn } from "@/lib/utils";

// Brand mark — single transparent-bg lockup PNG (L mark + "Lumi" wordmark
// baked together). Replaces the previous theme-aware split (separate
// black/white background squares + CSS-rendered wordmark) which had a
// subtle bg-color seam against the page background.
//
// Caveat: the wordmark color is baked dark, so this currently reads best
// on light surfaces. Dark theme will be revisited when we have a paired
// light-text variant.
export function BrandMark({
  className,
  size = "md",
}: {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
}) {
  // Image aspect is ~4:1 — set height, let width auto.
  const heightCls =
    size === "xl" ? "h-10" :
    size === "lg" ? "h-8" :
    size === "sm" ? "h-5" :
                    "h-7"; // md default
  return (
    <img
      src="/lumi-lockup.png"
      alt="Lumi"
      draggable={false}
      className={cn("w-auto select-none object-contain", heightCls, className)}
    />
  );
}
